import * as React from "react";
import { Text } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
import { PriceTag } from "../../PriceTag/components/PriceTagOrIncluded/PriceTag/PriceTag.js";
const PriceTagOrIncluded = ({
  originalPrice,
  discountedPrice,
  discountText,
  className,
  step,
  textVariant,
  pricePrefix,
  size
}) => {
  const { getLabel, hasLabel } = useIntl();
  if (originalPrice === 0) {
    const labelKey = step ? `products.glasses.configurator.priceIsZero.${step}` : "products.glasses.configurator.priceIsZero";
    return hasLabel(labelKey) ? /* @__PURE__ */ React.createElement(Text, { variant: textVariant, component: "span", className }, getLabel(labelKey)) : null;
  }
  if (discountedPrice === 0 && discountText && discountText?.length > 0) {
    return /* @__PURE__ */ React.createElement(Text, { variant: textVariant, component: "span", className }, discountText);
  }
  return /* @__PURE__ */ React.createElement(
    PriceTag,
    {
      className,
      originalPrice,
      discountedPrice,
      pricePrefix,
      size
    }
  );
};
export {
  PriceTagOrIncluded
};
//# sourceMappingURL=PriceTagOrIncluded.js.map
